import { Controller } from '@hotwired/stimulus'
import { SubscriptionSubmitValidation } from './mixins/subscription_submit_validation'
import { SubscriptionRecipeCheckboxValidation } from './mixins/subscription_recipe_checkbox_validation'

class AccountSubscriptionUpdateValidationController extends Controller {
  static targets = ['submitButton', 'validationMessage']

  connect() {
    this.checkValidation()
  }

  checkValidation() {
    if (!this.validateRecipeQuantities()) {
      this.disableSubmitForRecipes()
      return
    }

    this.enableSubmit()
  }
}

Object.assign(
  AccountSubscriptionUpdateValidationController.prototype,
  SubscriptionSubmitValidation,
  SubscriptionRecipeCheckboxValidation
)

export default AccountSubscriptionUpdateValidationController
